import React from 'react';
import { AlertCircle, Lock, Home } from 'lucide-react';

interface ModuleAccessErrorProps {
  error: {
    error: string;
    module: string;
    moduleDisplayName: string;
    isPremium: boolean;
    pricing: string;
    category: string;
    description: string;
    requiredRole: string;
  };
}

const ModuleAccessError: React.FC<ModuleAccessErrorProps> = ({ error }) => {
  const goToMainMenu = () => {
    window.location.href = '/admin/dashboard';
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        {/* Icon */}
        <div className="flex justify-center mb-6">
          {error.isPremium ? (
            <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center">
              <Lock className="w-8 h-8 text-white" />
            </div>
          ) : (
            <div className="w-16 h-16 bg-gradient-to-br from-yellow-500 to-orange-500 rounded-full flex items-center justify-center">
              <AlertCircle className="w-8 h-8 text-white" />
            </div>
          )}
        </div>

        {/* Title */}
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          {error.isPremium ? 'Premium Feature' : 'Feature Not Available'}
        </h2>

        {/* Message */}
        <p className="text-gray-600 mb-8 leading-relaxed">
          {error.error}
        </p>

        {/* Main Menu Button */}
        <button
          onClick={goToMainMenu}
          className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-blue-700 transition-colors flex items-center justify-center"
        >
          <Home className="w-4 h-4 mr-2" />
          Return to Main Menu
        </button>
      </div>
    </div>
  );
};

export default ModuleAccessError;
